import { render, staticRenderFns } from "./Lojas.vue?vue&type=template&id=e147a338"
import script from "./Lojas.vue?vue&type=script&lang=js"
export * from "./Lojas.vue?vue&type=script&lang=js"
import style0 from "./Lojas.vue?vue&type=style&index=0&id=e147a338&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports